import React from 'react';
import {legacy_createStore as createStore, applyMiddleware, compose, combineReducers} from 'redux';

export const hi =(furi)=>({type : 'imaga', furi});
export const ho =(furi)=>({type : 'sana', furi});
export const he =(furi)=>({type : 'izuna', furi});

const akina =(state={furi : 10}, action)=>{
    switch(action.type){
        case 'imaga' :
            return{
                ...state,
                furi : action.furi
            };
        default :
            return state;    
    }
};

const midori =(state=[], action)=>{
    switch(action.type){
        case 'sana' :
            return [...state, action.furi];
            
        default :
            return state;    
    }
};

const mahena =(state={}, action)=>{
    switch(action.type){
        case 'izuna' :
            return action.furi;
            
        default :
            return state;    
    }
};

const reducer = combineReducers({akina, midori, mahena});

export const store = createStore(reducer, compose(applyMiddleware()))

